import { render, staticRenderFns } from "./SitePageFilters.vue?vue&type=template&id=15dedb9d&"
import script from "./SitePageFilters.vue?vue&type=script&lang=js&"
export * from "./SitePageFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports